
import { EQLSearchSignedClass, EQLSearch } from "@eco/client"
import { useMemo } from "react"

export const useEqlSearchSignedQuery = (query: EQLSearchSignedClass): EQLSearch => {
    return useMemo((): EQLSearch => {
        const result: EQLSearch = {
            ...query,
            config: {}
        }
        if (process.env.REACT_APP_SIGN_QUERY) {
            result.config!.headers = {
                'Authorization' : `Bearer ${query?.signature}`
            }
        }
        return result
    }, [query])
}

